import React from 'react';
import { Text, StyleSheet, View } from 'react-native';

const message =
  'ご請求金額が299,000円を超えているため、コンビニ払いはご利用いただけません。お手数ですが、銀行振込にてお支払いください。';

export default function MaximumAmountOfCombiniPaymentCard() {
  return (
    <View style={styles.container}>
      <Text style={styles.header}>ご請求のお支払いについて。</Text>
      <Text style={styles.message}>{message}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 24,
    borderRadius: 24,
    backgroundColor: '#fff',
    marginBottom: 24,
  },
  header: {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 24,
    color: '#ff2751',
    marginBottom: 8,
  },
  message: {
    fontSize: 13,
    fontWeight: '300',
    lineHeight: 16,
    color: '#2a2e32',
  },
});
